module.exports = __webpack_public_path__ + "static/img/8.2ed1210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/8.png
// module id = 0K1G
// module chunks = 1